<!-- <button mat-icon-button class="button-dialog" style="float: right;"
[mat-dialog-close]=false><mat-icon style="font-size: 36px;font-weight: 700;">close</mat-icon></button> -->

<div class="dialog-title">
  @if (this.Behandler.Id > -1) {
    <div style="vertical-align:middle; display: flex; align-items:center;">
      <mat-icon class="dialog-icon">medical_services</mat-icon>
      {{'Aufträge.NachfrageBehandlerBearbeiten' | translate}}
    </div>
  }
  @if (0 > this.Behandler.Id) {
    <div style="vertical-align:middle; display: flex; align-items:center;" >
      <mat-icon class="dialog-icon">medical_services</mat-icon>
      {{'Stammdaten.NeuerBehandler' | translate}}
    </div>
  }
</div>

<mat-divider></mat-divider>

<div mat-dialog-content>
  @if (this.Behandler.Titel != 20) {
    <div class="row no-padding">
      <div class="col-md-6 col-left">
        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
          <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
          <mat-select [(ngModel)]="this.Behandler.Anrede" required placeholder="{{'RequiredPlaceholderSelect' | translate}}">
            <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
            <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-right">
        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
          <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
          <mat-select [(ngModel)]="this.Behandler.Titel">
            @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
              <mat-option [value]="titel.Id">
                {{titel.Name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }

  @if (this.Behandler.Titel == 20) {
    <div class="row no-padding">
      <div class="col-md-4 col-left">
        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
          <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
          <mat-select [(ngModel)]="this.Behandler.Anrede" required placeholder="{{'RequiredPlaceholderSelect' | translate}}">
            <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
            <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-middle">
        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
          <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
          <mat-select [(ngModel)]="this.Behandler.Titel" required placeholder="{{'RequiredPlaceholderSelect' | translate}}">
            @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
              <mat-option required [value]="titel.Id">
                {{titel.Name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-right">
        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
          <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
          <input matInput [(ngModel)]="this.Behandler.TitelSonstige" placeholder="" type="text">
        </mat-form-field>
      </div>
    </div>
  }

  <div class="row no-padding">
    <div class="col-md-6 col-left">
      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
        <mat-label>{{'Neuauftrag.Arzt.Vorname' | translate}}</mat-label>
        <input matInput [(ngModel)]="this.Behandler.Vorname" required placeholder="{{'RequiredPlaceholderSelect' | translate}}" type="text">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-right">
      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
        <mat-label>{{'Neuauftrag.Arzt.Name' | translate}}</mat-label>
        <input matInput [(ngModel)]="this.Behandler.Name" required placeholder="{{'RequiredPlaceholderSelect' | translate}}" type="text">
      </mat-form-field>
    </div>
  </div>

  <div class="row no-padding">
    <div class="col-md-4 col-left">
      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
        <mat-label>{{'Geburtsdatum' | translate}}</mat-label>

        <input matInput style="margin: 0px"
          [ngModel]="this.Behandler.Geburtsdatum | date:'dd.MM.yyyy'"
          (ngModelChange)="this.Behandler.Geburtsdatum=this.oroservice.ChangeDate($event);"
          autocomplete='off'>
          <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='this.Behandler.Geburtsdatum'>

          <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
          <mat-datepicker #pickerVon></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-middle">
        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
          <mat-label>{{'Sprache' | translate}}</mat-label>
          <mat-select [(ngModel)]="this.Behandler.Sprache">
            <mat-option [value]="1">DE</mat-option>
            <mat-option [value]="2">FR</mat-option>
            <!-- <mat-option [value]="3">IT</mat-option> -->
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-right">
        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
          <mat-label>{{'Fachrichtung' | translate}}</mat-label>
          <mat-select [(ngModel)]="this.Behandler.Fachrichtung" required placeholder="{{'RequiredPlaceholderSelect' | translate}}">
            @for (richtung of this.oroservice.kundeninfo.Fachrichtungen; track richtung) {
              <mat-option
                [value]="richtung.Id">{{richtung.Name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>



  <div mat-dialog-actions>
    <button mat-flat-button color="primary" class="button-dialog" [disabled]="!canSubmit()" (click)=" clickSave()">
      <mat-icon>save</mat-icon>&nbsp;{{'Speichern' | translate}}
    </button>

    <button mat-flat-button color="primary" class="button-dialog" [mat-dialog-close]=false>
      <mat-icon>clear</mat-icon>&nbsp;{{'Startseite.Abbrechen' | translate}}
    </button>
  </div>